var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      attrs: { role: "application" },
      on: {
        touchstart: _vm.handleTouchStart,
        touchmove: _vm.handleTouchMove,
        touchend: _vm.handleTouchEnd,
        mousedown: _vm.handleMouseDown,
        mousemove: _vm.handleMouseMove,
        mouseup: _vm.handleMouseUp,
        wheel: function ($event) {
          $event.preventDefault()
          return _vm.handleWheel.apply(null, arguments)
        },
      },
    },
    [
      _vm.isKrpanoActive
        ? _c("krpano", {
            ref: "krpano",
            staticClass: "krpano-wrapper",
            attrs: {
              xml: "",
              html5: "webgl+only",
              mwheel: "",
              "pass-query-parameters": "",
              "lazy-load": "",
              webglsettings: { depth: true, webgl2: true },
              hooks: _vm.hooks,
              focus: false,
            },
            on: { panoCreated: _vm.krpanoInit },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }